import { parse, getQuarter, getYear, format } from 'date-fns';

const quarterFormat: typeof format = (date) => {
  const parsedDate = parse(date);
  return `Q${getQuarter(parsedDate)} ${getYear(parsedDate)}`;
};

export default quarterFormat;
